import React from 'react'

function HomePageNavBar() {

  return (
    <div className='HomePageNavBar'>
        <div className="homepageNavBar-logo-card">
            <h3>Welcome to Fashioniste - Your Fashion Journal</h3>
        </div>
    </div>
  )
}

export default HomePageNavBar